'use client';

import { useSyncExternalStore } from 'react';

const unsubscribe = (): void => {};

const subscribeToNothing = (): (() => void) => unsubscribe;

const getClientSnapshot = (): boolean => true;

const getServerSnapshot = (): boolean => false;

/**
 * Whether React has finished hydrating, so a control whose behaviour lives in a React handler
 * can refuse to act until it exists.
 *
 * Refusing is the settled answer, not a stopgap on the way to progressive enhancement: a visitor
 * without JS who got through a `<form action={serverAction}>` sign-in would land on a hub that
 * needs JS regardless, so the work buys nothing for the person it appears to serve.
 */
export const useIsHydrated = (): boolean =>
  useSyncExternalStore(subscribeToNothing, getClientSnapshot, getServerSnapshot);
